import { render, staticRenderFns } from "./Torrents.vue?vue&type=template&id=7f9f389b&scoped=true&lang=pug&"
import script from "./Torrents.vue?vue&type=script&lang=js&"
export * from "./Torrents.vue?vue&type=script&lang=js&"
import style0 from "./Torrents.vue?vue&type=style&index=0&id=7f9f389b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9f389b",
  null
  
)

export default component.exports